// @ts-nocheck
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useCampaign } from "../../views/Campaign/CampaignContext";
import { useAuth } from "../../providers/AuthProvider";
import { isAdmin } from "../../utils/helpers";

export default function LaunchCampaignReminder() {
  const navigator = useNavigate();
  const { t } = useTranslation("", { keyPrefix: "sidenav" });
  const { isLoaded, gifts, actions } = useCampaign();
  const { user } = useAuth();

  if (
    isAdmin(user) ||
    !isLoaded ||
    gifts.length ||
    actions.length ||
    window.location.href.includes("/campaign")
  ) {
    return null;
  }

  return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #3f5efb",
        borderRadius: 2,
        background: "#f0f3ff",
        textAlign: "center",
        my: 3,
      }}
    >
      <Typography fontWeight={600}>
        <Trans
          t={t}
          i18nKey="launchCampaign"
          components={[<Typography fontWeight="600" component="span" color="primary" />]}
        />
      </Typography>
      <br />
      <img src="/assets/actions/add-button.svg" alt="Add" />
      <br />
      <Typography fontWeight={400} mb={2}>
        {t("launchCampaignHelper")}
      </Typography>
      <Button sx={{ width: "100%" }} variant="contained" onClick={() => navigator("/campaign")}>
        {t("createCampaign")}
      </Button>
    </Box>
  );
}
